<template>
    <div class="vx-checkbox">
        <div class="inline-flex items-center">
            <vs-checkbox v-bind="$attrs" v-model="localValue" :disabled="disabled">
                <slot>
                    <span v-if="label" class="ml-2" :class="{ disabled: disabled }">
                        {{ label }}
                    </span>
                </slot>
            </vs-checkbox>
        </div>
    </div>
</template>

<script>
export default {
    name: 'vx-checkbox',
    props: {
        value: {
            type: [Boolean, Array]
        },
        label: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
